import { render, staticRenderFns } from "./EntityChangesDetail.view.vue?vue&type=template&id=3cc588bf&"
import script from "./EntityChangesDetail.view.vue?vue&type=script&lang=ts&"
export * from "./EntityChangesDetail.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports